export default __webpack_public_path__ + "static/media/Pricing.302922ee.png";